import { buildQueryFilters, createApiHook } from '@/plugins/app/api'
import _ from 'lodash'
import axios from '@/plugins/w/axios/models/axios'
import { filter } from 'cypress/types/bluebird'
import { format } from 'date-fns'

export type ReservationState = 'CANCELED' | 'MODIFIED' | 'CANCELED_AND_UNPAID' | 'CANCELED_AND_CANCELED_PAYMENT'
export type ReservationSource = 'INTERNET' | 'LZ' | 'B2B' | 'OTHER'
export type ReservationSort = 'reservationDateTime' | 'orderCreatedAt'
export type ReservationSortDirection = 'asc' | 'desc'

export interface ReservationsFilters {
	date_from?: string
	date_to?: string
	search?: string
	patient_external_id?: string
	order_variable_symbol?: string
	states?: ReservationState[]
	sort?: {
		property?: ReservationSort
		direction?: ReservationSortDirection
	}
}

export const QUERY_KEY = 'lis-patients'

export const DEFAULT_FILTERS: ReservationsFilters = {
	search: '',
	date_from: format(new Date(), 'yyyy-MM-dd'),
	date_to: format(new Date(), 'yyyy-MM-dd'),
	patient_external_id: '',
	order_variable_symbol: '',
	states: [],
	sort: {
		property: 'reservationDateTime',
		direction: 'desc'
	}
}

export const fetchFn = async (pagination: Pagination, filters: ReservationsFilters = {}) => {
	const query = fetchQuery(pagination, filters)
	const params = buildQueryFilters(query)

	return axios.get_auth(`v1/oc/reservations?${params}`).catch((error) => Promise.reject(error.response || error))
}

export const fetchQuery = (pagination: Pagination, filters: ReservationsFilters) => {
	const filtersWithDefaults = _.defaults(filters, DEFAULT_FILTERS)

	const query = {
		per_page: Number(pagination.per_page),
        page: Number(pagination.current_page),
		search: filtersWithDefaults.search?.trim() || '',
		date_from: filtersWithDefaults.date_from,
		date_to: filtersWithDefaults.date_to,
		patient_external_id: filtersWithDefaults.patient_external_id,
		order_variable_symbol: filtersWithDefaults.order_variable_symbol,
		states: filtersWithDefaults.states,
		sort: filtersWithDefaults.sort
	}

	return query
}

export const useGetReservations = createApiHook(fetchFn, QUERY_KEY, fetchQuery)